import React from "react";
import { Box, Container, Typography, Paper } from "@mui/material";

function PlayerStatsHardcore() {
  return (
    <Box sx={{ flexGrow: 1, py: 4 }}>
      <Container maxWidth="lg">
        <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
          <Typography variant="h3" component="h1" gutterBottom>
            MCV Hardcore Stats
          </Typography>

          <Box
            component="iframe"
            src="https://mcverse.city/stats-hardcore/index.html#hof"
            sx={{
              width: "100%",
              height: "70vh",
              border: "none",
              borderRadius: "4px",
              mt: 2,
              mb: 2,
              boxShadow: 2,
            }}
            title="MCVerse Hardcore Stats"
            allowFullScreen
          />
        </Paper>
      </Container>
    </Box>
  );
}

export default PlayerStatsHardcore;
